import React, { useState } from "react";

import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";

function Subscription() {

  const [subscriptions, setSubscriptions] = useState([]);

  const [form, setForm] = useState({
    customer: "",
    plot: "",
    type: "Monthly",
    amount: ""
  });

  const handleChange = (e) => {

    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {

    e.preventDefault();

    setSubscriptions([
      ...subscriptions,
      form
    ]);

    setForm({
      customer: "",
      plot: "",
      type: "Monthly",
      amount: ""
    });
  };

  return (

    <div>

      <Navbar />

      <Sidebar />

      <div className="main-content">

        <h1>Subscriptions</h1>

        <form onSubmit={handleSubmit}>

          <input
            type="text"
            name="customer"
            placeholder="Customer"
            value={form.customer}
            onChange={handleChange}
          />

          <input
            type="text"
            name="plot"
            placeholder="Plot"
            value={form.plot}
            onChange={handleChange}
          />

          <select
            name="type"
            value={form.type}
            onChange={handleChange}
          >
            <option>Monthly</option>
            <option>Quarterly</option>
            <option>Yearly</option>
          </select>

          <input
            type="number"
            name="amount"
            placeholder="Amount"
            value={form.amount}
            onChange={handleChange}
          />

          <button type="submit">
            Add Subscription
          </button>

        </form>

      </div>

    </div>
  );
}

export default Subscription;